export default __webpack_public_path__ + "static/media/eye-close.7bf1208e.svg";